import * as R from "ramda";

export const maskAccountNumber = (num, prefix = "....") =>
  `${prefix}${R.splitAt(-4, num)[1]}`;

export const defaultPrevented = fn => e => {
  e.preventDefault();
  fn && fn();
};

export const shortenLocaleName = R.replace(/-(.*)$/, "");

export const defaultLanguage = "en";

export const getLanguageSuffix = language =>
  language === defaultLanguage ? "" : `_${language}`;

export { default as ClickOutside } from "./ClickOutside";

export const filterDeleted = list =>
  list ? R.reject(R.prop("deleted"), list) : undefined;

export const stripTrailingSlash = str => str.replace(/\/$/, "");



// WEBPACK FOOTER //
// ./src/utils/index.js